import React from 'react';
import styled from 'styled-components';

const StyledLabel = styled.label`
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-black);
  display: block;
  margin-bottom: 8px;
`;

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => {
    return (
      <StyledLabel
        className={className}
        ref={ref}
        {...props}
      />
    );
  }
);

Label.displayName = 'Label';
